import * as React from "react";
const SvgFiRrLeaderboardAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-leaderboard-alt_svg__a)">
      <path
        fill="#062147"
        d="M19 0H5C2.243 0 0 2.243 0 5v14c0 2.757 2.243 5 5 5h14c2.757 0 5-2.243 5-5V5c0-2.757-2.243-5-5-5m3 19c0 1.654-1.346 3-3 3H5c-1.654 0-3-1.346-3-3V5c0-1.654 1.346-3 3-3h14c1.654 0 3 1.346 3 3zm-9-3a1 1 0 0 1-1 1h-1a1 1 0 0 1 0-2h1a1 1 0 0 1 1 1m0-8a1 1 0 0 1-1 1h-1a1 1 0 0 1 0-2h1a1 1 0 0 1 1 1m7 8.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m.47-9.171a.5.5 0 0 1-.148.554l-1.183.964.489 1.396a.5.5 0 0 1-.169.553.5.5 0 0 1-.578.023l-1.377-.897-1.354.906a.5.5 0 0 1-.755-.566l.47-1.413-1.189-.967a.5.5 0 0 1 .323-.881h1.5l.531-1.49a.5.5 0 0 1 .938 0l.531 1.49h1.5a.5.5 0 0 1 .47.329zM6.5 16a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 6.5 16M5 6.5a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 5 6.5m3.978 4.043c.09.222-.108.457-.375.457H4.398c-.268 0-.466-.235-.375-.457C4.389 9.644 5.356 9 6.501 9s2.112.644 2.478 1.543zm0 8c.09.222-.108.457-.375.457H4.398c-.268 0-.466-.235-.375-.457C4.389 17.644 5.356 17 6.501 17s2.112.644 2.478 1.543z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-leaderboard-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLeaderboardAlt;
